<section class="skillsWrap " (click)="drop();">
  <div class="left-sidebar">
    <app-sidebar></app-sidebar>
  </div>
  <div class="right-panel">
      <h4 class="pageTitle"> Skills </h4>
      <div class="form-group">
          <label> Skills <span class="orangeText">*</span> </label>
          <div class="skill">
              <input type="text" class="form-control" placeholder="Enter" [(ngModel)]="userQuestion" name="userQuestion" id="userQuestions" (ngModelChange)="search()"/>
              <ul class="dropdown" *ngIf="show" >
                  <li *ngFor="let message of skillList;let i=index;" (click)="selectedSkill(i);drop()">
                    <a href="javascript:void(0)">{{message.name}}</a> 
                    </li> 
                </ul>
            </div>
            <label class="small-highlights firstlCaptial">You can add up to 50 skills </label>
            <div class="text-danger" *ngIf="form.controls['skillIdsArray'].hasError('required') && showError">
                *Please enter Skills.
            </div>
        </div>
        <form  [formGroup]="form" (ngSubmit)="onSubmit()">

          <div *ngIf="addedSkills.length > 0">
            <h5 class="subTitle pt-3"> Added skills </h5>
            <div class="form-group">
                <ul class="addedskills">
                    <li *ngFor="let skill of addedSkills; let i=index;"> {{skill.name || skill.skillDetails.name}} <a href="javascript:void(0);" (click)="removeSkills(i)"> × </a> </li>
                </ul>
                <div class="text-danger" *ngIf="addedSkills.length > 50 && showError">
                    *You can add up to 50 skills. Please remove additional skills.
                </div>
            </div>
          </div>

          <div *ngIf="skillList.length > 0">
            <h5 class="subTitle"> Suggested skills </h5>
            <div class="form-group">
                <ul class="suggestedskills">
                    <li *ngFor="let message of skillList;let i=index;" (click)="selectedSkill(i)">
                          {{message.name}} 
                    </li> 
                </ul>
            </div>
          </div>

          <div class="form-group">
            <input type="submit" value="Continue" class="commonBtn width50 mt-4">
          </div>

      </form>
  </div>
</section>